/**
 * EmptyState: heading, description and an optional action for a list, table or page with nothing to show (also used
 * for "no access"). Carbon has no empty-state component in @carbon/react, so this follows Carbon's empty-state
 * pattern with Carbon type and spacing tokens only.
 *
 * Props: `heading`, `description`, `action` (a ready Button), `headingLevel` (2 or 3, default 2, see PageHeader for
 * the hierarchy rule).
 */
import type { ReactNode } from 'react';
import './components.scss';

export interface EmptyStateProps {
  heading: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  headingLevel?: 2 | 3;
}

export function EmptyState({ heading, description, action, headingLevel = 2 }: EmptyStateProps) {
  const Heading = `h${headingLevel}` as const;
  return (
    <div className="pos-empty-state">
      <Heading className="pos-empty-state__heading">{heading}</Heading>
      {description && <p className="pos-empty-state__description">{description}</p>}
      {action}
    </div>
  );
}
